export const colors: string[] = [
	"rgb(0, 0, 0)",         // Negro
	"rgb(0, 130, 200)",     // Azul vivo
	"rgb(60, 180, 75)",     // Verde brillante
	"rgb(230, 25, 75)",     // Rojo intenso
	"rgb(255, 225, 25)",    // Amarillo fuerte
	"rgb(245, 130, 48)",    // Naranja
	"rgb(145, 30, 180)",    // Púrpura fuerte
	"rgb(70, 240, 240)",    // Cian claro
	"rgb(240, 50, 230)",    // Rosa fuerte
	"rgb(210, 245, 60)",    // Lima clara
	"rgb(250, 190, 190)",   // Rosa pastel
	"rgb(0, 128, 128)",     // Verde azulado oscuro
	"rgb(230, 190, 255)",   // Lavanda claro
	"rgb(170, 110, 40)",    // Marrón oscuro
	"rgb(128, 128, 0)"      // Verde oliva
];